export const PLA_MARKET_STORE_LOCALIZED = 'PLA - Market Store Localized';
export const PLA_EXPERIENCE_EXPELLED = 'PLA - Experience Expelled';
export const SEARCH_TERM_NO_RESULT = 'Search Term No Result';
export const PLA_EXPERIENCE_LANDING = 'PLA - Experience Landed';
export const LAMINATE_COLOR_MISSING_IN_CLASSIFICATION =
  'Laminate color not found when switching classification';
export const IMAGE_MODAL_CLICKED = 'Image Modal Clicked';
export const VISUALIZATION_IMAGE_ERROR = 'Visualization Image Error';

export default async (actionName, actionObject) =>
  window?.newrelic?.addPageAction(actionName, actionObject);
